// Публичные адреса блога собирает фронт: бэк отдаёт только слаги, а в API
// слаг передаётся query-параметром (его роутер не пропускает дефис в пути).

export const BLOG_ROOT = "/blog";

export const blogTopicUrl = (topicSlug?: string | null) =>
  topicSlug ? `${BLOG_ROOT}/${topicSlug}` : BLOG_ROOT;

export const blogTagUrl = (tagSlug: string) => `${BLOG_ROOT}/tag/${tagSlug}`;

// Тема в адресе статьи — это primaryTopic.slug
export const blogArticleUrl = (article: {
  slug?: string;
  primaryTopic?: { slug?: string } | null;
}) => {
  const topic = article?.primaryTopic?.slug;
  if (!article?.slug) return BLOG_ROOT;
  return topic ? `${BLOG_ROOT}/${topic}/${article.slug}` : `${BLOG_ROOT}/${article.slug}`;
};
